import { CustomField, ENTITY_TYPES } from '@sales-center/common'
import { customValuesToInputModel } from '@user/components/CustomFields'
import { SplitOpportunityInput } from '@user/store/opportunity'
import { ISaveServicesForLaterFormModel } from '../FormContents/typings'

export function formModelToInput(
  model: ISaveServicesForLaterFormModel,
  entityId: number,
  entityType: ENTITY_TYPES,
  customFields: CustomField[],
): SplitOpportunityInput {
  return {
    originEntityId: entityId,
    originEntityType: entityType,
    customFieldValues: customValuesToInputModel(model, customFields),
    expectedClosingDate: model.expectedClosingDate,
    originProductIds: model.serviceIds.map((x) => Number(x)),
    salesFunnelId: Number(model.salesFunnelId),
    shouldSyncNextActionDate: model.shouldSyncNextActionDate,
  }
}
